var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, styled, } from '@mui/material';
var TableContainerStyled = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        border: "1px solid ".concat(theme.backrs.colors['Colors/Border/border-secondary']),
        borderRadius: theme.backrs.radius['radius-md'],
    });
});
export var GenericTable = function (_a) {
    var headers = _a.headers, children = _a.children, ariaLabel = _a.ariaLabel, _b = _a.stickyHeader, stickyHeader = _b === void 0 ? false : _b;
    return (_jsx(TableContainer, { component: TableContainerStyled, children: _jsxs(Table, { size: "small", "aria-label": ariaLabel, stickyHeader: stickyHeader, children: [_jsx(TableHead, { children: _jsx(TableRow, { children: headers.map(function (header, idx) { return (_jsx(TableCell, { sx: tableHeaderLabelSx, children: header }, idx)); }) }) }), _jsx(TableBody, { sx: tableBodySx, children: children })] }) }));
};
var tableHeaderLabelSx = function (_a) {
    var backrs = _a.backrs, typography = _a.typography;
    return (__assign(__assign({}, typography['text-xs-semibold']), { color: backrs.colors['Colors/Text/text-quaternary'], backgroundColor: backrs.colors['Colors/Background/bg-secondary'], paddingBlock: backrs.spacing['spacing-lg'], '&:first-of-type': {
            paddingLeft: backrs.spacing['spacing-3xl'],
        }, '&:last-of-type': {
            paddingRight: backrs.spacing['spacing-3xl'],
        } }));
};
var tableBodySx = function (_a) {
    var backrs = _a.backrs;
    return ({
        '& tr:last-of-type td': {
            border: 0,
        },
        '& td:first-of-type': {
            paddingLeft: backrs.spacing['spacing-3xl'],
        },
        '& td:last-of-type': {
            paddingRight: backrs.spacing['spacing-3xl'],
        },
    });
};
